import React from 'react';
export var SVGRecom = function (_a) {
    var className = _a.className;
    return (React.createElement("svg", { viewBox: "0 0 18 19", className: className },
        React.createElement("path", { d: "M15.067 7.5c1.289 0 1.933.907 1.933 2.722 0 1.385-.375 3.237-1.125 5.556C15.444 17.259 14.485 18 13 18H1V8.892h3.097a2 2 0 0 0 1.87-1.288L8.212 1.7c2.26.518 3.093 1.588 2.501 3.211-.592 1.623-.473 2.485.356 2.588h3.997zM4.5 9v9", "stroke-width": "1.5", fill: "none", "fill-rule": "evenodd" })));
};
//# sourceMappingURL=SVGRecom.js.map